export const formatInputData = ({
  dataToFormat,
  labelKey = 'name',
  valueKey = null,
  labelFormat,
}) =>
  (dataToFormat || []).map(data => {
    const label = data[labelKey]
    const isFnString =
      typeof labelFormat === 'function' && typeof labelFormat(data) === 'string'

    return {
      ...data,
      label: isFnString ? labelFormat(data) : label,
      value: valueKey ? data[valueKey] : data,
    }
  })

export const formattedAllInputData = (allDataToFormat = []) => {
  const formattedData = new Map()

  for (const inputToFormat of allDataToFormat) {
    const inputFormatted = formatInputData({...inputToFormat})
    formattedData.set(
      inputToFormat?.identifier || inputToFormat?.valueKey,
      inputFormatted,
    )
  }

  return formattedData
}

export const zFill =(num, width) =>{
  var numberOutput = Math.abs(num);
  var length = num.toString().length;
  var zero = "0";
  
  if (width <= length) {
      if (num < 0) {
           return ("-" + numberOutput.toString()); 
      } else {
           return numberOutput.toString(); 
      }
  } else {
      if (num < 0) {
          return ("-" + (zero.repeat(width - length)) + numberOutput.toString()); 
      } else {
          return ((zero.repeat(width - length)) + numberOutput.toString()); 
      }
  }
}

export const validateNumber= (value) => {
  const re =/^\d+$/;
  return re.test(value);
}